/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/barcode-lookup`, controller.plan, makeLayout, render);
    router(`/dashboard/barcode-lookup/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/barcode-lookup/subscribe`, controller.newPlan, makeLayout, render);
};
